module.exports = {"130204001":"林西街道","130204002":"唐家庄街道","130204003":"古冶街道","130204004":"赵各庄街道","130204007":"京华街道","130204100":"范各庄镇","130204101":"卑家店镇","130204201":"王辇庄乡","130204202":"习家套乡","130204203":"大庄坨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130204.json
// module id = 83
// module chunks = 0